import { Component } from '@angular/core';

@Component({
  selector: 'rs-share-warning',
  templateUrl: 'share-warning.component.html',
  styleUrls: ['share-warning.component.scss']
})
export class ShareWarningPopupComponent {
}
